import { Navigate, Route, Routes } from 'react-router-dom';
import { RoleLayout } from '@/components/layout/RoleLayout';
import { nav } from './nav';
import { DashboardPage } from './pages/DashboardPage';
import { ChildrenPage } from './pages/ChildrenPage';
import { ChildDetailPage } from './pages/ChildDetailPage';
import { NoticesPage } from './pages/NoticesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { FeesPage } from './pages/FeesPage';
import { WalletPage } from './pages/WalletPage';
import { PaymentHistoryPage } from './pages/PaymentHistoryPage';
import { ResultsPage } from './pages/ResultsPage';
import { MessagesPage } from './pages/MessagesPage';
import { CalendarPage } from './pages/CalendarPage';
import { SettingsPage } from './pages/SettingsPage';
import { DocumentRequestsPage } from './pages/DocumentRequestsPage';

export function parentRoutes() {
  return (
    <Routes>
      <Route element={<RoleLayout title="Parent" base="/parent" nav={nav} />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="children" element={<ChildrenPage />} />
        <Route path="children/:id" element={<ChildDetailPage />} />
        <Route path="notices" element={<NoticesPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="fees" element={<FeesPage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="payment-history" element={<PaymentHistoryPage />} />
        <Route path="results" element={<ResultsPage />} />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="document-requests" element={<DocumentRequestsPage />} />
      </Route>
    </Routes>
  );
}
